import { css } from '@emotion/css';

import { AI_COLORS } from '@/components/LyearnAI/consts';

export const aiActionButtonStyles = css`
  border-radius: 6px;
  &:hover {
    background: ${AI_COLORS.chalkPink}cc;
  }
  .sparkle-icon {
    fill: ${AI_COLORS.lavenderBlue};
  }
`;
